import { equals, map, isNotEmpty, toString } from 'ramda';
import React, { useState, useRef } from 'react';
import { Alert, Tabs } from 'antd';
import classNames from 'classnames';
import { Title } from '../../components';
import Switch from '../../components/Switch';
import StatusComparison from './StatusComparison';
import FrameResult from './components/FrameResult';

const ComparisonDetails = ({ comparison }) => {
  const { comparisonDetails } = comparison;
  const [showActualPdf, setShowActualPdf] = useState(true);
  const [showDiff, setShowDiff] = useState(false);
  const [isScrollSynchronized, setIsScrollSynchronized] = useState(true);
  const referentFrameRef = useRef(null);
  const actualFrameRef = useRef(null);

  const tabItems = map((comparison) => {
    const { referentPdfId, actualPdfId, status, diffPngsIds, fileName } = comparison;

    const buttonComparison = (title, show, isActual) => (
      <button
        className={classNames({ 'cursor-default': equals('passed', status) })}
        onClick={() => {
          setShowActualPdf(isActual);
          setShowDiff(!isActual);
        }}
      >
        <h4
          className={`text-xl font-bold ${show ? 'text-flexi-text' : 'text-gray-300'}`}
        >
          {title}
        </h4>
      </button>
    );

    return {
      key: toString(referentPdfId),
      label: (
        <div className="flex flex-row items-center">
          <div className="flex justify-center items-center space-x-2">
            <StatusComparison status={status} />
            <h3 className="text-xl font-bold text-flexi-primary-color mb-0">{fileName}</h3>
          </div>
        </div>
      ),
      children: (
        <div className="w-full inline-flex">
          <div className="inline-flex justify-center space-x-6 flex-1">
            <div className="flex flex-col items-center space-y-4 w-full px-2">
              <h4 className="text-xl font-bold text-flexi-text">
                Document référent
              </h4>
              <FrameResult
                fileId={referentPdfId} isScrollSynchronized={isScrollSynchronized} frameRef={referentFrameRef}
                otherFrameRef={actualFrameRef} showDiff={showDiff} toCompare
              />
            </div>
          </div>
          <div className="inline-flex justify-center space-x-6 flex-1">
            <div className="flex flex-col items-center space-y-4 w-full px-2">
              <div className="inline-flex space-x-6">
                {buttonComparison('PDF généré', showActualPdf, true)}
                {equals('failed', status) && buttonComparison('Différences', showDiff, false)}
              </div>
              {showActualPdf && (
                <FrameResult
                  fileId={actualPdfId} isScrollSynchronized={isScrollSynchronized} frameRef={actualFrameRef}
                  otherFrameRef={referentFrameRef} toCompare
                />
              )}
              {showDiff && (
                <>
                  {isNotEmpty(diffPngsIds) ? (
                    <div className="flex flex-col items-center space-y-4 h-1000px overflow-auto">
                      <div className="overflow-auto">
                        {map((fileId) => (
                          <FrameResult
                            fileId={fileId} isImg frameRef={actualFrameRef}
                            otherFrameRef={referentFrameRef} toCompare
                          />
                        ))(diffPngsIds)}
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center space-y-4">
                      <Alert message="Le nombre de page du document généré est différent du document référent." type="error" showIcon />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )
    };
  })(comparisonDetails);

  return (
    <div>
      <div className="flex flex-row items-center">
        <Title title="Comparaison" />
        <div className="flex flex-row items-center pl-4">
          <Switch
            checked={isScrollSynchronized}
            onChange={() => setIsScrollSynchronized(!isScrollSynchronized)}
            label="Scroll simultané"
            onClick={() => setIsScrollSynchronized(!isScrollSynchronized)}
          />
        </div>
      </div>
      <Tabs items={tabItems} />
    </div>
  );
};

export default ComparisonDetails;
